import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const 
getProductionBatchList = createAsyncThunk("/getProductionBatchList", async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${baseUrl}productionOrder/api/v1/list`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response; 
  } catch (error) {
    console.error("Error fetching Production Batch", error);
    return rejectWithValue(error.response?.data?.message || "Failed to fetch Production Batch");
  }
});
